// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LoginForm-module__font-s-10___hIJCV {
  font-size: 10px !important;
}

.LoginForm-module__font-s-12___Ksqiw {
  font-size: 12px !important;
}

.LoginForm-module__font-s-13___y0x9P {
  font-size: 13px !important;
}

.LoginForm-module__font-s-14___eLFPF {
  font-size: 14px !important;
}

.LoginForm-module__font-s-15___JR99Y {
  font-size: 15px !important;
}

.LoginForm-module__font-s-16___Y3trC {
  font-size: 16px !important;
}

.LoginForm-module__font-s-18___Np_QU {
  font-size: 18px !important;
}

.LoginForm-module__font-s-20___eynDM {
  font-size: 20px !important;
}

.LoginForm-module__font-s-22___Qv_z9 {
  font-size: 22px !important;
}

.LoginForm-module__font-s-28___k04iK {
  font-size: 28px !important;
}

.LoginForm-module__font-w-400____MUJ7 {
  font-weight: 400 !important;
}

.LoginForm-module__font-w-500___gv71B {
  font-weight: 500 !important;
}

.LoginForm-module__font-w-600___dSvHy {
  font-weight: 600 !important;
}

.LoginForm-module__font-w-700___Dc3h7 {
  font-weight: 700 !important;
}

.LoginForm-module__p-5___bNcoJ {
  padding: 5px !important;
}

.LoginForm-module__p-12___egJzK {
  padding: 12px !important;
}

.LoginForm-module__p-16___BWjYh {
  padding: 16px !important;
}

.LoginForm-module__p-30___gVvEe {
  padding: 30px !important;
}

.LoginForm-module__p-b-0___uKSiS {
  padding-bottom: 0 !important;
}

.LoginForm-module__p-b-5___s147Q {
  padding-bottom: 5px !important;
}

.LoginForm-module__p-b-10___IcnDf {
  padding-bottom: 10px !important;
}

.LoginForm-module__p-b-12___YzTcJ {
  padding-bottom: 12px !important;
}

.LoginForm-module__p-b-16___iGF6Y {
  padding-bottom: 16px !important;
}

.LoginForm-module__p-b-18____4TW9 {
  padding-bottom: 18px !important;
}

.LoginForm-module__p-b-20___okcSK {
  padding-bottom: 20px !important;
}

.LoginForm-module__p-b-25___cKbMg {
  padding-bottom: 25px !important;
}

.LoginForm-module__p-b-30___YFatX {
  padding-bottom: 30px !important;
}

.LoginForm-module__p-b-50___jFj5a {
  padding-bottom: 50px !important;
}

.LoginForm-module__p-t-0___n1_Ru {
  padding-top: 0 !important;
}

.LoginForm-module__p-t-12___fzw7p {
  padding-top: 12px !important;
}

.LoginForm-module__p-t-16___RwIG7 {
  padding-top: 16px !important;
}

.LoginForm-module__p-t-18___UJs1g {
  padding-top: 18px !important;
}

.LoginForm-module__p-t-20___ifdKj {
  padding-top: 20px !important;
}

.LoginForm-module__p-t-30___UsHAf {
  padding-top: 30px !important;
}

.LoginForm-module__p-t-40___redXB {
  padding-top: 40px !important;
}

.LoginForm-module__p-t-50___yEE23 {
  padding-top: 50px !important;
}

.LoginForm-module__p-l-20___RW93z {
  padding-left: 20px !important;
}

.LoginForm-module__p-l-30___WMHAA {
  padding-left: 30px !important;
}

.LoginForm-module__p-l-40___uzjkw {
  padding-left: 40px !important;
}

.LoginForm-module__p-r-16___Mwdtl {
  padding-right: 16px !important;
}

.LoginForm-module__p-r-20___Q0Lf4 {
  padding-right: 20px !important;
}

.LoginForm-module__p-r-30___MXB93 {
  padding-right: 30px !important;
}

.LoginForm-module__p-r-50___xzp2K {
  padding-right: 50px !important;
}

.LoginForm-module__p-r-60___pt_SV {
  padding-right: 60px !important;
}

.LoginForm-module__m-b-1___vxwmi {
  margin-bottom: 1px !important;
}

.LoginForm-module__m-b-2___EKpHb {
  margin-bottom: 2px !important;
}

.LoginForm-module__m-b-6___UKgUi {
  margin-bottom: 6px !important;
}

.LoginForm-module__m-b-8___qtq2Y {
  margin-bottom: 8px !important;
}

.LoginForm-module__m-b-10___k8Gj7 {
  margin-bottom: 10px !important;
}

.LoginForm-module__m-b-14___BxKzA {
  margin-bottom: 14px !important;
}

.LoginForm-module__m-b-16___EZFbK {
  margin-bottom: 16px !important;
}

.LoginForm-module__m-b-20___rW61p {
  margin-bottom: 20px !important;
}

.LoginForm-module__m-b-22___Hb7q8 {
  margin-bottom: 22px !important;
}

.LoginForm-module__m-b-24___YLOZf {
  margin-bottom: 24px !important;
}

.LoginForm-module__m-b-30___CZ6QF {
  margin-bottom: 30px !important;
}

.LoginForm-module__m-b-32___V2Pr6 {
  margin-bottom: 32px !important;
}

.LoginForm-module__m-b-40___d3L5W {
  margin-bottom: 40px !important;
}

.LoginForm-module__m-t-2___qj4M9 {
  margin-top: 2px !important;
}

.LoginForm-module__m-t-3___nj1Oo {
  margin-top: 3px !important;
}

.LoginForm-module__m-t-4___Kzed8 {
  margin-top: 4px !important;
}

.LoginForm-module__m-t-5___U1qW8 {
  margin-top: 5px !important;
}

.LoginForm-module__m-t-8___KqD6F {
  margin-top: 8px !important;
}

.LoginForm-module__m-t-10___jxPhT {
  margin-top: 10px !important;
}

.LoginForm-module__m-t-15___X7Ms1 {
  margin-top: 15px !important;
}

.LoginForm-module__m-t-16___JGlZf {
  margin-top: 16px !important;
}

.LoginForm-module__m-t-20___dBi3V {
  margin-top: 20px !important;
}

.LoginForm-module__m-t-22___tbDb2 {
  margin-top: 22px !important;
}

.LoginForm-module__m-t-30___Aw7U0 {
  margin-top: 30px !important;
}

.LoginForm-module__m-t-32___Lhya1 {
  margin-top: 32px !important;
}

.LoginForm-module__m-l-auto___C8jOE {
  margin-left: auto !important;
}

.LoginForm-module__m-l-4___hQUig {
  margin-left: 4px !important;
}

.LoginForm-module__m-l-5___vP_1N {
  margin-left: 5px !important;
}

.LoginForm-module__m-l-6___GClW4 {
  margin-left: 6px !important;
}

.LoginForm-module__m-l-8___EYMDe {
  margin-left: 8px !important;
}

.LoginForm-module__m-l-10___DvG7v {
  margin-left: 10px !important;
}

.LoginForm-module__m-l-16___CwmEg {
  margin-left: 16px !important;
}

.LoginForm-module__m-l-20___p_MUE {
  margin-left: 20px !important;
}

.LoginForm-module__m-l-24___v0BMq {
  margin-left: 24px !important;
}

.LoginForm-module__m-l-30___jgyog {
  margin-left: 30px !important;
}

.LoginForm-module__m-l-35___N1SsB {
  margin-left: 35px !important;
}

.LoginForm-module__m-l-40___YX9PJ {
  margin-left: 40px !important;
}

.LoginForm-module__m-r-8___TjMwQ {
  margin-right: 8px !important;
}

.LoginForm-module__m-r-10___lsb7l {
  margin-right: 10px !important;
}

.LoginForm-module__m-r-16___q0aPw {
  margin-right: 16px !important;
}

.LoginForm-module__m-r-20___saDM4 {
  margin-right: 20px !important;
}

.LoginForm-module__m-r-24___gcWs4 {
  margin-right: 24px !important;
}

.LoginForm-module__m-r-30___m01Q1 {
  margin-right: 30px !important;
}

.LoginForm-module__m-r-40___qD0Jf {
  margin-right: 40px !important;
}

.LoginForm-module__border-r-3___jnCDs {
  border-radius: 3px !important;
}

.LoginForm-module__border-r-4___uwywq {
  border-radius: 4px !important;
}

.LoginForm-module__border-r-6___q5UH6 {
  border-radius: 6px !important;
}

.LoginForm-module__border-r-10___QBnuv {
  border-radius: 10px !important;
}

.LoginForm-module__border-r-12___KThVJ {
  border-radius: 12px !important;
}

.LoginForm-module__border-r-16___dGZH7 {
  border-radius: 16px !important;
}

.LoginForm-module__border-r-50___Qn_z9 {
  border-radius: 50% !important;
}

.LoginForm-module__primary-border____PIYf {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.LoginForm-module__primary-border-b___UIeoL {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.LoginForm-module__primary-border-t___oZtmO {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.LoginForm-module__primary-border-l___OrOqc {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.LoginForm-module__primary-border-r___Ubyav {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.LoginForm-module__secondary-border____ftH9 {
  border: 1px solid #637768;
}

.LoginForm-module__secondary-border-b___xfosn {
  border-bottom: 1px solid #637768;
}

.LoginForm-module__secondary-border-t___BM4wX {
  border-top: 1px solid #637768;
}

.LoginForm-module__secondary-border-l___YKnVA {
  border-left: 1px solid #637768;
}

.LoginForm-module__secondary-border-r___uV0Te {
  border-right: 1px solid #637768;
}

.LoginForm-module__gap-0___KRbJf {
  gap: 0 !important;
}

.LoginForm-module__gap-2___axYLs {
  gap: 2px !important;
}

.LoginForm-module__gap-4___9ZFos {
  gap: 4px !important;
}

.LoginForm-module__gap-5___upmSu {
  gap: 5px !important;
}

.LoginForm-module__gap-6___OByd3 {
  gap: 6px !important;
}

.LoginForm-module__gap-8___Vq2an {
  gap: 8px !important;
}

.LoginForm-module__gap-10___OWoVi {
  gap: 10px !important;
}

.LoginForm-module__gap-12____XyPF {
  gap: 12px !important;
}

.LoginForm-module__gap-14___VmpCB {
  gap: 14px !important;
}

.LoginForm-module__gap-16___xHjVu {
  gap: 16px !important;
}

.LoginForm-module__gap-18___KUn3c {
  gap: 18px !important;
}

.LoginForm-module__gap-20___zOi04 {
  gap: 20px !important;
}

.LoginForm-module__gap-24___bF5VO {
  gap: 24px !important;
}

.LoginForm-module__gap-26___GxNJd {
  gap: 26px !important;
}

.LoginForm-module__gap-30___bDfHu {
  gap: 30px !important;
}

.LoginForm-module__gap-32___NYLIl {
  gap: 32px !important;
}

.LoginForm-module__gap-40___EpfFq {
  gap: 40px !important;
}

.LoginForm-module__gap-50___HltrO {
  gap: 50px !important;
}

.LoginForm-module__flex-1___z3ziQ {
  flex: 1;
}

.LoginForm-module__flex-none___me7vn {
  flex: none !important;
}

.LoginForm-module__flex-column___flS7E {
  display: flex;
  flex-direction: column !important;
}

.LoginForm-module__flex-row___zOVUi {
  display: flex;
  flex-direction: row !important;
}

.LoginForm-module__vertically-centered____r7wm {
  display: flex;
  align-items: center !important;
}

.LoginForm-module__horizontally-centered___OkVIu {
  display: flex;
  justify-content: center !important;
}

.LoginForm-module__horizontally-end___EyaT1 {
  display: flex;
  justify-content: end !important;
}

.LoginForm-module__vertically-start___po1dV {
  display: flex;
  align-items: start !important;
}

.LoginForm-module__space-between___Kvz6S {
  display: flex;
  justify-content: space-between !important;
}

.LoginForm-module__flex-wrap___yN75o {
  flex-wrap: wrap !important;
}

.LoginForm-module__height-100___TSLSv {
  height: 100%;
}

.LoginForm-module__width-50___D8zs1 {
  width: 50% !important;
}

.LoginForm-module__width-100___C2KpS {
  width: 100%;
}

.LoginForm-module__cursor-pointer___wbR9m {
  cursor: pointer;
}

.LoginForm-module__cursor-not-allowed___pclsa {
  cursor: not-allowed !important;
}

.LoginForm-module__absolute-centered___mrKdr {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.LoginForm-module__absolute___G_UoW {
  position: absolute;
}

.LoginForm-module__relative___Vb0Lx {
  position: relative;
}

.LoginForm-module__fixed___xVcwP {
  position: fixed;
}

.LoginForm-module__visible___RnlPk {
  opacity: 1;
}

.LoginForm-module__invisible___WZRMi {
  opacity: 0;
}

.LoginForm-module__col-90___FWA4s {
  width: 90% !important;
}

.LoginForm-module__col-auto___SvGiL {
  width: auto !important;
}

.LoginForm-module__medical-tabs___q2crO {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.LoginForm-module__medical-table-new___MXbMC {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.LoginForm-module__medical-table-new___MXbMC:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.LoginForm-module__medical-table-new___MXbMC::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.LoginForm-module__medical-table-new___MXbMC::-webkit-scrollbar-track {
  display: none;
}
.LoginForm-module__medical-table-new___MXbMC.LoginForm-module__no-pagination___eephz {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.LoginForm-module__medical-table-new___MXbMC.LoginForm-module__no-pagination___eephz:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.LoginForm-module__medical-table-new___MXbMC.LoginForm-module__no-pagination___eephz::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.LoginForm-module__medical-table-new___MXbMC.LoginForm-module__no-pagination___eephz::-webkit-scrollbar-track {
  display: none;
}

.LoginForm-module__medical-table-empty___ew1Dl {
  padding: 14px 40px !important;
}

.LoginForm-module__icon-btn___peUcd {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.LoginForm-module__search-icon___mA0k2 {
  width: 24px;
  height: 24px;
  align-self: center;
}

.LoginForm-module__disable-select___fvHMp {
  user-select: none;
}

.LoginForm-module__break-word___WLIHm {
  word-break: break-word;
}

.LoginForm-module__popup-clear-btn___iibkt {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.LoginForm-module__scroll-m-b-20___o4Yv8 {
  scroll-margin-bottom: 20px;
}

.LoginForm-module__container___XVzt8 {
  padding-top: 3vh;
}
.LoginForm-module__container___XVzt8 .LoginForm-module__inputContainer___kLhGx {
  align-items: center;
}
.LoginForm-module__container___XVzt8 .LoginForm-module__buttonContainer___sXBrG {
  width: max-content;
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  padding-top: 2vh;
  gap: 16px;
}
.LoginForm-module__container___XVzt8 .LoginForm-module__buttonContainer___sXBrG .LoginForm-module__loginButton___UA_VX {
  align-self: stretch;
}
.LoginForm-module__container___XVzt8 .LoginForm-module__buttonContainer___sXBrG .LoginForm-module__googleButton___yrhRl {
  border-radius: 4px;
  height: 40px;
  min-width: 200px;
}
.LoginForm-module__container___XVzt8 .LoginForm-module__loginInput___M95DN input {
  padding: 20px;
  background-color: #f8f8f8;
}
.LoginForm-module__container___XVzt8 .LoginForm-module__errorContainer___BlscZ {
  height: 5vh;
  align-items: center;
  align-self: center;
  margin-bottom: 1vh;
}
.LoginForm-module__container___XVzt8 .LoginForm-module__errorContainer___BlscZ .LoginForm-module__errorText___Y1Omh {
  font-family: var(--font-family);
  font-weight: 400;
  font-size: 1rem;
  color: #f86363;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/pages/Login/LoginForm/LoginForm.module.scss","webpack://./../common/src/styles/global/_mixins.scss","webpack://./../common/src/styles/global/_fonts.scss","webpack://./../common/src/styles/global/_weights.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,gBAAA;AA8pBF;AA5pBE;EACE,mBAAA;AA8pBJ;AA3pBE;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,cAAA;EACA,gBAAA;EACA,SAAA;AA6pBJ;AA3pBI;EACE,mBAAA;AA6pBN;AA1pBI;EACE,kBAAA;EACA,YAAA;EACA,gBAAA;AA4pBN;AAvpBI;EACE,aAAA;EACA,yBAAA;AAypBN;AArpBE;EACE,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;AAupBJ;AArpBI;EEfF,+BApBO;EAqBP,gBCzBQ;ED0BR,eAAA;EFeI,cAAA;AAypBN","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.container {\n  padding-top: 3vh;\n\n  .inputContainer {\n    align-items: center;\n  }\n\n  .buttonContainer {\n    width: max-content;\n    display: flex;\n    flex-direction: column;\n    margin: 0 auto;\n    padding-top: 2vh;\n    gap: 16px;\n\n    .loginButton {\n      align-self: stretch;\n    }\n\n    .googleButton {\n      border-radius: 4px;\n      height: 40px;\n      min-width: 200px;\n    }\n  }\n\n  .loginInput {\n    input {\n      padding: 20px;\n      background-color: #f8f8f8;\n    }\n  }\n\n  .errorContainer {\n    height: 5vh;\n    align-items: center;\n    align-self: center;\n    margin-bottom: 1vh;\n\n    .errorText {\n      @include get-font($roboto, $regular, medium);\n      color: get-color(red);\n    }\n  }\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n","@use 'sass:map';\n@use 'sass:meta';\n@use 'sizes';\n\n// font families\n// TODO: rename this variable\n$roboto: var(--font-family);\n\n// functions\n@function get-font-size($font-size: null) {\n  // check font size exists\n  @if (map.has-key(sizes.$font-sizes, $font-size)) {\n    $value: map.get(sizes.$font-sizes, $font-size);\n    @if meta.type-of($value) == number {\n      // return font size\n      @return $value;\n    }\n\n    @return null;\n  }\n\n  @return null;\n}\n\n// mixins\n@mixin get-font($font-family: $roboto, $font-weight: 400, $font-size: null) {\n  font-family: $font-family;\n  font-weight: $font-weight;\n  font-size: get-font-size($font-size);\n}\n","$extra-light: 200;\n$light: 300;\n$regular: 400;\n$medium: 500;\n$semi-bold: 600;\n$bold: 700;\n$heavy: 900;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `LoginForm-module__font-s-10___hIJCV`,
	"fontS12": `LoginForm-module__font-s-12___Ksqiw`,
	"fontS13": `LoginForm-module__font-s-13___y0x9P`,
	"fontS14": `LoginForm-module__font-s-14___eLFPF`,
	"fontS15": `LoginForm-module__font-s-15___JR99Y`,
	"fontS16": `LoginForm-module__font-s-16___Y3trC`,
	"fontS18": `LoginForm-module__font-s-18___Np_QU`,
	"fontS20": `LoginForm-module__font-s-20___eynDM`,
	"fontS22": `LoginForm-module__font-s-22___Qv_z9`,
	"fontS28": `LoginForm-module__font-s-28___k04iK`,
	"fontW400": `LoginForm-module__font-w-400____MUJ7`,
	"fontW500": `LoginForm-module__font-w-500___gv71B`,
	"fontW600": `LoginForm-module__font-w-600___dSvHy`,
	"fontW700": `LoginForm-module__font-w-700___Dc3h7`,
	"p5": `LoginForm-module__p-5___bNcoJ`,
	"p12": `LoginForm-module__p-12___egJzK`,
	"p16": `LoginForm-module__p-16___BWjYh`,
	"p30": `LoginForm-module__p-30___gVvEe`,
	"pB0": `LoginForm-module__p-b-0___uKSiS`,
	"pB5": `LoginForm-module__p-b-5___s147Q`,
	"pB10": `LoginForm-module__p-b-10___IcnDf`,
	"pB12": `LoginForm-module__p-b-12___YzTcJ`,
	"pB16": `LoginForm-module__p-b-16___iGF6Y`,
	"pB18": `LoginForm-module__p-b-18____4TW9`,
	"pB20": `LoginForm-module__p-b-20___okcSK`,
	"pB25": `LoginForm-module__p-b-25___cKbMg`,
	"pB30": `LoginForm-module__p-b-30___YFatX`,
	"pB50": `LoginForm-module__p-b-50___jFj5a`,
	"pT0": `LoginForm-module__p-t-0___n1_Ru`,
	"pT12": `LoginForm-module__p-t-12___fzw7p`,
	"pT16": `LoginForm-module__p-t-16___RwIG7`,
	"pT18": `LoginForm-module__p-t-18___UJs1g`,
	"pT20": `LoginForm-module__p-t-20___ifdKj`,
	"pT30": `LoginForm-module__p-t-30___UsHAf`,
	"pT40": `LoginForm-module__p-t-40___redXB`,
	"pT50": `LoginForm-module__p-t-50___yEE23`,
	"pL20": `LoginForm-module__p-l-20___RW93z`,
	"pL30": `LoginForm-module__p-l-30___WMHAA`,
	"pL40": `LoginForm-module__p-l-40___uzjkw`,
	"pR16": `LoginForm-module__p-r-16___Mwdtl`,
	"pR20": `LoginForm-module__p-r-20___Q0Lf4`,
	"pR30": `LoginForm-module__p-r-30___MXB93`,
	"pR50": `LoginForm-module__p-r-50___xzp2K`,
	"pR60": `LoginForm-module__p-r-60___pt_SV`,
	"mB1": `LoginForm-module__m-b-1___vxwmi`,
	"mB2": `LoginForm-module__m-b-2___EKpHb`,
	"mB6": `LoginForm-module__m-b-6___UKgUi`,
	"mB8": `LoginForm-module__m-b-8___qtq2Y`,
	"mB10": `LoginForm-module__m-b-10___k8Gj7`,
	"mB14": `LoginForm-module__m-b-14___BxKzA`,
	"mB16": `LoginForm-module__m-b-16___EZFbK`,
	"mB20": `LoginForm-module__m-b-20___rW61p`,
	"mB22": `LoginForm-module__m-b-22___Hb7q8`,
	"mB24": `LoginForm-module__m-b-24___YLOZf`,
	"mB30": `LoginForm-module__m-b-30___CZ6QF`,
	"mB32": `LoginForm-module__m-b-32___V2Pr6`,
	"mB40": `LoginForm-module__m-b-40___d3L5W`,
	"mT2": `LoginForm-module__m-t-2___qj4M9`,
	"mT3": `LoginForm-module__m-t-3___nj1Oo`,
	"mT4": `LoginForm-module__m-t-4___Kzed8`,
	"mT5": `LoginForm-module__m-t-5___U1qW8`,
	"mT8": `LoginForm-module__m-t-8___KqD6F`,
	"mT10": `LoginForm-module__m-t-10___jxPhT`,
	"mT15": `LoginForm-module__m-t-15___X7Ms1`,
	"mT16": `LoginForm-module__m-t-16___JGlZf`,
	"mT20": `LoginForm-module__m-t-20___dBi3V`,
	"mT22": `LoginForm-module__m-t-22___tbDb2`,
	"mT30": `LoginForm-module__m-t-30___Aw7U0`,
	"mT32": `LoginForm-module__m-t-32___Lhya1`,
	"mLAuto": `LoginForm-module__m-l-auto___C8jOE`,
	"mL4": `LoginForm-module__m-l-4___hQUig`,
	"mL5": `LoginForm-module__m-l-5___vP_1N`,
	"mL6": `LoginForm-module__m-l-6___GClW4`,
	"mL8": `LoginForm-module__m-l-8___EYMDe`,
	"mL10": `LoginForm-module__m-l-10___DvG7v`,
	"mL16": `LoginForm-module__m-l-16___CwmEg`,
	"mL20": `LoginForm-module__m-l-20___p_MUE`,
	"mL24": `LoginForm-module__m-l-24___v0BMq`,
	"mL30": `LoginForm-module__m-l-30___jgyog`,
	"mL35": `LoginForm-module__m-l-35___N1SsB`,
	"mL40": `LoginForm-module__m-l-40___YX9PJ`,
	"mR8": `LoginForm-module__m-r-8___TjMwQ`,
	"mR10": `LoginForm-module__m-r-10___lsb7l`,
	"mR16": `LoginForm-module__m-r-16___q0aPw`,
	"mR20": `LoginForm-module__m-r-20___saDM4`,
	"mR24": `LoginForm-module__m-r-24___gcWs4`,
	"mR30": `LoginForm-module__m-r-30___m01Q1`,
	"mR40": `LoginForm-module__m-r-40___qD0Jf`,
	"borderR3": `LoginForm-module__border-r-3___jnCDs`,
	"borderR4": `LoginForm-module__border-r-4___uwywq`,
	"borderR6": `LoginForm-module__border-r-6___q5UH6`,
	"borderR10": `LoginForm-module__border-r-10___QBnuv`,
	"borderR12": `LoginForm-module__border-r-12___KThVJ`,
	"borderR16": `LoginForm-module__border-r-16___dGZH7`,
	"borderR50": `LoginForm-module__border-r-50___Qn_z9`,
	"primaryBorder": `LoginForm-module__primary-border____PIYf`,
	"primaryBorderB": `LoginForm-module__primary-border-b___UIeoL`,
	"primaryBorderT": `LoginForm-module__primary-border-t___oZtmO`,
	"primaryBorderL": `LoginForm-module__primary-border-l___OrOqc`,
	"primaryBorderR": `LoginForm-module__primary-border-r___Ubyav`,
	"secondaryBorder": `LoginForm-module__secondary-border____ftH9`,
	"secondaryBorderB": `LoginForm-module__secondary-border-b___xfosn`,
	"secondaryBorderT": `LoginForm-module__secondary-border-t___BM4wX`,
	"secondaryBorderL": `LoginForm-module__secondary-border-l___YKnVA`,
	"secondaryBorderR": `LoginForm-module__secondary-border-r___uV0Te`,
	"gap0": `LoginForm-module__gap-0___KRbJf`,
	"gap2": `LoginForm-module__gap-2___axYLs`,
	"gap4": `LoginForm-module__gap-4___9ZFos`,
	"gap5": `LoginForm-module__gap-5___upmSu`,
	"gap6": `LoginForm-module__gap-6___OByd3`,
	"gap8": `LoginForm-module__gap-8___Vq2an`,
	"gap10": `LoginForm-module__gap-10___OWoVi`,
	"gap12": `LoginForm-module__gap-12____XyPF`,
	"gap14": `LoginForm-module__gap-14___VmpCB`,
	"gap16": `LoginForm-module__gap-16___xHjVu`,
	"gap18": `LoginForm-module__gap-18___KUn3c`,
	"gap20": `LoginForm-module__gap-20___zOi04`,
	"gap24": `LoginForm-module__gap-24___bF5VO`,
	"gap26": `LoginForm-module__gap-26___GxNJd`,
	"gap30": `LoginForm-module__gap-30___bDfHu`,
	"gap32": `LoginForm-module__gap-32___NYLIl`,
	"gap40": `LoginForm-module__gap-40___EpfFq`,
	"gap50": `LoginForm-module__gap-50___HltrO`,
	"flex1": `LoginForm-module__flex-1___z3ziQ`,
	"flexNone": `LoginForm-module__flex-none___me7vn`,
	"flexColumn": `LoginForm-module__flex-column___flS7E`,
	"flexRow": `LoginForm-module__flex-row___zOVUi`,
	"verticallyCentered": `LoginForm-module__vertically-centered____r7wm`,
	"horizontallyCentered": `LoginForm-module__horizontally-centered___OkVIu`,
	"horizontallyEnd": `LoginForm-module__horizontally-end___EyaT1`,
	"verticallyStart": `LoginForm-module__vertically-start___po1dV`,
	"spaceBetween": `LoginForm-module__space-between___Kvz6S`,
	"flexWrap": `LoginForm-module__flex-wrap___yN75o`,
	"height100": `LoginForm-module__height-100___TSLSv`,
	"width50": `LoginForm-module__width-50___D8zs1`,
	"width100": `LoginForm-module__width-100___C2KpS`,
	"cursorPointer": `LoginForm-module__cursor-pointer___wbR9m`,
	"cursorNotAllowed": `LoginForm-module__cursor-not-allowed___pclsa`,
	"absoluteCentered": `LoginForm-module__absolute-centered___mrKdr`,
	"absolute": `LoginForm-module__absolute___G_UoW`,
	"relative": `LoginForm-module__relative___Vb0Lx`,
	"fixed": `LoginForm-module__fixed___xVcwP`,
	"visible": `LoginForm-module__visible___RnlPk`,
	"invisible": `LoginForm-module__invisible___WZRMi`,
	"col90": `LoginForm-module__col-90___FWA4s`,
	"colAuto": `LoginForm-module__col-auto___SvGiL`,
	"medicalTabs": `LoginForm-module__medical-tabs___q2crO`,
	"medicalTableNew": `LoginForm-module__medical-table-new___MXbMC`,
	"noPagination": `LoginForm-module__no-pagination___eephz`,
	"medicalTableEmpty": `LoginForm-module__medical-table-empty___ew1Dl`,
	"iconBtn": `LoginForm-module__icon-btn___peUcd`,
	"searchIcon": `LoginForm-module__search-icon___mA0k2`,
	"disableSelect": `LoginForm-module__disable-select___fvHMp`,
	"breakWord": `LoginForm-module__break-word___WLIHm`,
	"popupClearBtn": `LoginForm-module__popup-clear-btn___iibkt`,
	"scrollMB20": `LoginForm-module__scroll-m-b-20___o4Yv8`,
	"container": `LoginForm-module__container___XVzt8`,
	"inputContainer": `LoginForm-module__inputContainer___kLhGx`,
	"buttonContainer": `LoginForm-module__buttonContainer___sXBrG`,
	"loginButton": `LoginForm-module__loginButton___UA_VX`,
	"googleButton": `LoginForm-module__googleButton___yrhRl`,
	"loginInput": `LoginForm-module__loginInput___M95DN`,
	"errorContainer": `LoginForm-module__errorContainer___BlscZ`,
	"errorText": `LoginForm-module__errorText___Y1Omh`
};
module.exports = ___CSS_LOADER_EXPORT___;
